import { configureStore, getDefaultMiddleware  } from '@reduxjs/toolkit'
import { reducers } from './index'
import { ReduxKEY, loadState } from './browser-storage';
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";

export const store = configureStore({
  devTools: true,
  reducer: reducers,
  preloadedState: loadState(ReduxKEY),
  middleware: () => getDefaultMiddleware({
    serializableCheck: false,
    }).concat(createStateSyncMiddleware())
})

export default store;